import React, { useEffect, useRef } from "react";

const CareerTech = () => {
  const titleRef = useRef(null);
  const paraRef = useRef(null);
  const paraRef1 = useRef(null);
  const datadetailRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            // Remove class when element goes out of view so it re-triggers on scroll again
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    const elements = [
      titleRef.current,
      paraRef.current,
      paraRef1.current,
      datadetailRef.current,
      imgRef.current,
    ];
    elements.forEach((el) => el && observer.observe(el));

    return () => {
      elements.forEach((el) => el && observer.unobserve(el));
    };
  }, []);

  return (
    <div className="container-fluid  pb-5" id="careers">
      <div className="container">
        <div className="row">
          <div
            ref={titleRef}
            className="title_line text-center p-5 animate-title"
          >
            Career
          </div>
          <div>
            <p ref={paraRef} className="text-center animate-para">
              Admin & HR cum Social Media & Accounts Executive We’re searching
              for a versatile professional who can juggle admin, HR, social
              media, and basic accounts with ease. If you’re organized,
              digitally savvy, and enjoy variety in your work, you might be the
              perfect fit for this role. Join Technoserv today and enjoy the
              freedom to learn and grow.
              <br />
              Roles and Responsibilities <br /> <br />
            </p>
          </div>

          <div ref={paraRef1} className="col-md-12 animate-para">
            <div className="row">
              <div className="col-md-4 border-right">
                <div className="careerSec">
                  <center>
                    {" "}
                    <strong>What You’ll Do?</strong>
                  </center>
                  <br />
                  <br />
                  <ul>
                    <li>Keep daily operations running smoothly</li> <br />
                    <li>
                      {" "}
                      Support HR functions - from recruitment, employee records,
                      onboarding, to communication. Manage our social media.
                    </li>
                    <br />
                    <li>
                      {" "}
                      presence - create posts, engage audiences, and track
                    </li>
                    <br />
                    <li>
                      {" "}
                      performance. Handle basic accounts - expenses, invoices,
                      and records to support the team.
                    </li>
                    <br />
                  </ul>
                </div>
              </div>

              <div className="col-md-4 border-right">
                <div className="careerSec">
                  <center>
                    {" "}
                    <strong>What We’re Looking For</strong>
                  </center>
                  <br />
                  <br />
                  <ul>
                    <li>
                      {" "}
                      Bachelor’s degree in Business Administration, HR,
                      Commerce, or a related field.
                    </li>{" "}
                    <br />
                    <li>
                      {" "}
                      2+ years of experience in admin, HR, or a multifunctional
                      role.
                    </li>
                    <br />
                    <li>
                      {" "}
                      Skilled in MS Office, Canva, and accounting tools
                      (Tally/Zoho/Excel).
                    </li>
                    <br />
                    <li>
                      {" "}
                      Strong communication, organization, and multitasking
                      abilities.
                    </li>
                    <br />
                  </ul>
                </div>
              </div>

              <div className="col-md-4">
                <div className="careerSec">
                  <center>
                    <strong>Bonus Points If You Are</strong>
                  </center>
                  <br />
                  <br />
                  <ul>
                    <li> A self-starter with attention to detail.</li> <br />
                    <li>
                      {" "}
                      Comfortable working independently in a small or mid-sized
                      team.
                    </li>
                    <br />
                    <li> Social media aware with basic design skills.</li>
                    <br />
                    <li>
                      {" "}
                      Trustworthy and discreet with sensitive information.
                    </li>
                    <br />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerTech;
